__turbopack_context__.v({
  "main": "Home-module__jKgjFW__main",
});
